import React from "react";
const columns = [
    { label: "X Wins", key: "xWins", testId: "stat-x-wins" },
    { label: "Draws", key: "draws", testId: "stat-draws" },
    { label: "O Wins", key: "oWins", testId: "stat-o-wins" },
];
export const Stats = ({ stats }) => {
    return (React.createElement("table", { className: "text-xl text-gray-600 text-center" },
        React.createElement("thead", null,
            React.createElement("tr", null, columns.map(({ label }) => (React.createElement("th", { key: label, className: "px-4 py-1 font-medium" }, label))))),
        React.createElement("tbody", null,
            React.createElement("tr", null, columns.map(({ key, testId }) => (React.createElement("td", { key: key, className: "px-4 py-1", "data-testid": stats ? testId : undefined }, stats ? (stats[key]) : (React.createElement("div", { className: "h-4 w-6 mx-auto rounded bg-gray-200 animate-pulse" })))))))));
};
